import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/services";

const card = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.6, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] } }),
};

export default function Services() {
  return (
    <section id="services" className="bg-background py-20 md:py-32" data-testid="services-section">
      <div className="mx-auto max-w-[1500px] px-5 md:px-10">
        <div className="grid md:grid-cols-12 gap-6 items-end mb-14">
          <div className="md:col-span-8">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-primary mb-4">/ Core services</p>
            <h2 className="font-display font-extrabold uppercase tracking-tighter text-4xl md:text-6xl leading-[0.9]">
              One partner.<br />Global reach. Trusted execution.
            </h2>
          </div>
          <p className="md:col-span-4 font-sans text-muted-foreground text-base leading-relaxed">
            From a single laptop to multinational infrastructure programs across 70+ countries, we
            manage the full technology lifecycle — securely, sustainably and with documented compliance.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border-t border-l border-border">
          {SERVICES.map((s, i) => (
            <motion.article
              key={s.n}
              custom={i}
              variants={card}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-60px" }}
              data-testid={`service-card-${s.n}`}
              className="group relative border-r border-b border-border bg-background hover:bg-foreground hover:text-background transition-colors duration-300"
            >
              <Link to={`/services/${s.slug}`} className="block p-8 md:p-10" data-testid={`service-link-${s.slug}`}>
                <div className="flex items-start justify-between mb-8">
                  <s.icon size={28} strokeWidth={1.5} className="text-primary" />
                  <span className="font-mono text-xs text-muted-foreground group-hover:text-background/50">{s.n}</span>
                </div>
                <span className="inline-block font-mono text-[10px] uppercase tracking-widest border border-current px-2 py-1 mb-4 text-primary group-hover:text-primary">
                  {s.tag}
                </span>
                <h3 className="font-display font-bold text-2xl tracking-tight mb-3">{s.title}</h3>
                <p className="font-sans text-sm leading-relaxed text-muted-foreground group-hover:text-background/70">{s.short}</p>
                <ArrowUpRight size={20} className="mt-6 opacity-0 group-hover:opacity-100 group-hover:text-primary transition-opacity" />
              </Link>
            </motion.article>
          ))}
          <div className="hidden lg:flex border-r border-b border-border bg-primary text-white p-10 flex-col justify-between">
            <p className="font-mono text-xs uppercase tracking-widest">Not sure where to start?</p>
            <a href="/#quote" className="font-display font-extrabold text-3xl tracking-tight leading-none hover:underline">
              Book a free asset assessment →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
